import React, { useEffect, useRef, useState } from "react";

import User1 from "../../assets/Persons/person5.png";
import User2 from "../../assets/Persons/person6.png";
import User3 from "../../assets/Persons/person1.png";
import { ArrowLeft, ArrowRight } from "react-feather";
import { ReactComponent as Star } from "../../assets/icons/StartBlue.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {firestore} from "../../firebase.config";

const CustomerReviews = ({mTop = "mt-20"}) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const sliderRef = useRef(null);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    firestore.collection("testimonials").get().then(qSnap => {
      if(!qSnap.empty){
        const data = qSnap.docs.map(doc => ({...doc.data(), id: doc.id}));
        setReviews(data)
      }
    })
  }, [])

  const settings = {
    className: "center",
    centerMode: true,
    accessibility: true,
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    centerPadding: "28%",
    beforeChange: (oldIndex, newIndex) => setActiveSlide(newIndex),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerPadding: "10%",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
    ],
  };

  const nextSlide = () => sliderRef.current.slickNext();
  const prevSlide = () => sliderRef.current.slickPrev();

  return (
    <div className={`bg-white rounded-4xl overflow-hidden shadow-md px-4 py-8 ${mTop}`} id="reviews">
      <h2 className="font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-center my-8">
        Customer Reviews
      </h2>

      <Slider {...settings} ref={sliderRef}>
        { reviews.map((item, index) => (
          <div
            key={item.id}
            className={`p-4 ${
              activeSlide === index ? "opacity-100" : "opacity-50"
            }`}
          >
            <div
              className={`border  ${
                activeSlide === index ? "border-primary" : "border-gray-300"
              } rounded-[20px] xl:px-10 md:px-0 px-4 pt-10 pb-20 relative mb-20 md:h-[350px] sm:h-[300px]`}
            >
              <div className="flex flex-col justify-center w-full items-center gap-4">
                <ul className="flex gap-2">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <li key={index}>
                      <Star className="text-primary h-5 w-5" />
                    </li>
                  ))}
                </ul>
                <p className="text-xl text-tertiary text-center md:w-[90%] w-full line-clamp-6 overflow-hidden">
                  "{item.review}"
                </p>
              </div>

              <div className={`absolute flex flex-col items-center -bottom-20 left-1/2 translate-x-[-50%]`}>
                <div className="border-[12px] border-white rounded-full overflow-hidden w-fit">
                  <img
                    src={item.img || User1}
                    alt="person"
                    className="w-24 h-24 mx-auto"
                  />
                </div>
                <h4 className="font-semibold text-base text-tertiary text-center -mt-2 ">
                  {item.name}{item.company ? <span > ({item.company})</span> : ""}
                </h4>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <div className="w-full flex gap-4 justify-center mt-8">
        <button onClick={prevSlide} className="bg-primary p-3 rounded-full">
          <ArrowLeft className="h-5 w-5 text-white" />
        </button>
        <button onClick={nextSlide} className="bg-primary p-3 rounded-full">
          <ArrowRight className="h-5 w-5 text-white" />
        </button>
      </div>
    </div>
  );
};

export default CustomerReviews;
